import { CommonModule } from '@angular/common';
import { Component, Input, output } from '@angular/core';

@Component({
    selector: 'app-navigation-dropdown',
    imports: [CommonModule],
    templateUrl: './navigation-dropdown.component.html',
})
export class NavigationDropdownComponent {
    @Input() isVisible: boolean;
    @Input() dropdownPositionClassName: string;
    @Input() dropdownContainerClassName: string;

    closeDropdown = output<null>();
}
